/* Keep background video playing, everywhere, without any visible control.

   Muted inline video is supposed to autoplay. Three things stop it:

     • iOS Low Power Mode and Low Data Mode block autoplay outright, whatever
       the markup says
     • a tab restored from the background comes back with media paused
     • a play() that was in flight when something reset the element is dropped

   Rather than show a play button, this listens for the first real interaction
   of any kind — touch, pointer, key, scroll — and retries every paused muted
   video at that moment. A user gesture grants media permission for the page,
   so the retry succeeds where the automatic attempt did not, and the visitor
   never sees a control or knows anything was refused.

   It also re-checks whenever the tab becomes visible again, and watches for
   videos that quietly pause themselves mid-session. Videos the visitor has
   deliberately paused are left alone: only muted, autoplay-marked background
   video is ever touched. */
(function(){
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(RM) return;

  function candidates(){
    return [].slice.call(document.querySelectorAll('video[autoplay]'))
      .filter(function(v){ return v.muted && v.paused; });
  }

  function nudge(){
    candidates().forEach(function(v){
      /* Off-screen video is left alone — the browser is right to hold it, and
         forcing it wastes bandwidth and battery. */
      var r = v.getBoundingClientRect();
      var onScreen = r.bottom > 0 && r.top < (window.innerHeight || 0) &&
                     r.right > 0 && r.left < (window.innerWidth || 0);
      if(!onScreen) return;
      var p;
      try{ p = v.play(); }catch(e){ return; }
      if(p && p.catch) p.catch(function(){});
    });
  }

  var unlocked = false;
  function unlock(){
    if(unlocked) return;
    unlocked = true;
    nudge();
    ['pointerdown','touchstart','keydown','scroll'].forEach(function(t){
      window.removeEventListener(t, unlock, true);
    });
  }

  ['pointerdown','touchstart','keydown','scroll'].forEach(function(t){
    window.addEventListener(t, unlock, {capture:true, passive:true});
  });

  document.addEventListener('visibilitychange', function(){
    if(!document.hidden) nudge();
  });

  /* A light periodic check catches anything that pauses itself — iOS does this
     after certain interruptions — without polling hard enough to cost battery. */
  setInterval(function(){ if(!document.hidden && unlocked) nudge(); }, 4000);

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nudge);
  else nudge();
  window.addEventListener('load', nudge);
})();
